<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="titlepage" id="_idContainer000">
<p class="pl-author1"><a id="_idTextAnchor000"></a>Terri Reed</p>
<p class="pl-author1">and</p>
<p class="pl-header1">USA TODAY <span class="bold">Bestselling Author</span></p>
<p class="pl-author">Valerie Hansen</p>
<p class="pl-title">Fatal Pursuit</p>
<p class="pl-header"><span class="bold">Previously published as</span> Seeking the Truth <span class="bold">and</span> Trail of Danger</p>
<p class="pl-logo"><span class="bold"><img alt="logo" height="70" src="image/LI_2020.png"/></span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Title_Page.vue?92faa108